<template>
    <v-dialog v-model="dialog" persistent width="500" transition="wildcard-transition">
        <div class="d-flex flex-column justify-center align-center elevation-15 pistas-content">
            <div
                class="pistas-content d-flex flex-column justify-center align-center position-relative"
            >
                <div class="bee-img d-flex flex-row justify-center align-center position-absolute">
                    <div>
                        <img :src="beecoinImg" alt="pistas imagen de modal" />
                    </div>
                    <div>
                        <span class="white--text mt-n6 text-capitalize">{{ msg_beecoins }}</span>
                    </div>
                </div>
                <div class="p-img d-flex flex-column justify-center align-center">
                    <img :src="varitaImg" alt="pistas imagen de modal" />
                    <v-btn rounded color="#877ab6" class="white--text mt-n6 text-capitalize"
                        >{{ wildcard_price }} {{ $t('beecoins') }}</v-btn
                    >
                </div>
                <div class="pa-5 mx-5">
                    <span class="text-h6 white--text pa-5 font-weight-lighter">
                        {{ $t('bookReading.wildcard_50_50') }}
                    </span>
                </div>
                <div class="px-5 mx-5">
                    <span class="white--text text-body-1">
                        {{ $t('bookReading.wildcard_buy_msg') }}
                    </span>
                </div>
                <v-card-actions class="d-flex justify-center align-center ma-4">
                    <v-spacer></v-spacer>
                    <v-btn color="white" class="px-5 py-5" rounded outlined @click="close">
                        {{ $t('go_back') }}
                    </v-btn>
                    <v-btn color="secondary" class="px-5 py-5" rounded @click="confirmAction">
                        {{ $t('bookReading.buy_wildcard') }}
                    </v-btn>
                </v-card-actions>
            </div>
        </div>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
        count_beecoins: { type: [String, Number], default: 0 },
        wildcard_price: { type: [String, Number], default: 0 },
    },
    data() {
        return {
            varitaImg: require('@/assets/img/gamifications/desafios-varita.svg'),
            beecoinImg: require('@/assets/img/gamifications/beecoin-3.svg'),
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        confirmAction() {
            this.$emit('confirm')
        },
    },
    computed: {
        msg_beecoins() {
            return `${this.$t('bookReading.have')} ${this.count_beecoins} ${this.$t('beecoins')}`
        },
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.pistas-content {
    border-radius: 26px;
    background: linear-gradient(180deg, #6f5fa4 0%, #261c48 100%);
}
.items-unset {
    align-items: unset !important;
}
</style>
